export var AndroidMethodName;
(function (AndroidMethodName) {
    AndroidMethodName["toast"] = "xlShowToast";
    AndroidMethodName["report"] = "xlReportStatistics";
    AndroidMethodName["closeView"] = "xlCloseWindow";
})(AndroidMethodName || (AndroidMethodName = {}));
export var IOSMethodName;
(function (IOSMethodName) {
    IOSMethodName["toast"] = "toastMessage";
    IOSMethodName["report"] = "trackEvent";
    IOSMethodName["closeView"] = "xlCloseView";
})(IOSMethodName || (IOSMethodName = {}));
export var MacMethodName;
(function (MacMethodName) {
})(MacMethodName || (MacMethodName = {}));
export var PLATFORM;
(function (PLATFORM) {
    PLATFORM["MAC"] = "mac";
    PLATFORM["PC"] = "pc";
    PLATFORM["IOS"] = "ios";
    PLATFORM["ANDROID"] = "android";
    PLATFORM["ACCOUNT"] = "account";
    PLATFORM["XBASE"] = "xbase";
})(PLATFORM || (PLATFORM = {}));
export var METHODS;
(function (METHODS) {
    METHODS["OPTIONS"] = "OPTIONS";
    METHODS["GET"] = "GET";
    METHODS["HEAD"] = "HEAD";
    METHODS["POST"] = "POST";
    METHODS["PUT"] = "PUT";
    METHODS["DELETE"] = "DELETE";
    METHODS["PATCH"] = "PATCH";
    METHODS["TRACE"] = "TRACE";
    METHODS["CONNECT"] = "CONNECT";
})(METHODS || (METHODS = {}));
export const YINGYONGBAO_URL = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.xunlei.downloadprovider&ckey=CK1470052035866';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksaUJBSVg7QUFKRCxXQUFZLGlCQUFpQjtJQUMzQiwwQ0FBcUIsQ0FBQTtJQUNyQixrREFBNkIsQ0FBQTtJQUM3QixnREFBMkIsQ0FBQTtBQUM3QixDQUFDLEVBSlcsaUJBQWlCLEtBQWpCLGlCQUFpQixRQUk1QjtBQUVELE1BQU0sQ0FBTixJQUFZLGFBSVg7QUFKRCxXQUFZLGFBQWE7SUFDdkIsdUNBQXNCLENBQUE7SUFDdEIsc0NBQXFCLENBQUE7SUFDckIsMENBQXlCLENBQUE7QUFDM0IsQ0FBQyxFQUpXLGFBQWEsS0FBYixhQUFhLFFBSXhCO0FBRUQsTUFBTSxDQUFOLElBQVksYUFBZ0I7QUFBNUIsV0FBWSxhQUFhO0FBQUUsQ0FBQyxFQUFoQixhQUFhLEtBQWIsYUFBYSxRQUFHO0FBRTVCLE1BQU0sQ0FBTixJQUFZLFFBT1g7QUFQRCxXQUFZLFFBQVE7SUFDbEIsdUJBQVcsQ0FBQTtJQUNYLHFCQUFTLENBQUE7SUFDVCx1QkFBVyxDQUFBO0lBQ1gsK0JBQW1CLENBQUE7SUFDbkIsK0JBQW1CLENBQUE7SUFDbkIsMkJBQWUsQ0FBQTtBQUNqQixDQUFDLEVBUFcsUUFBUSxLQUFSLFFBQVEsUUFPbkI7QUFFRCxNQUFNLENBQU4sSUFBWSxPQVVYO0FBVkQsV0FBWSxPQUFPO0lBQ2pCLDhCQUFtQixDQUFBO0lBQ25CLHNCQUFXLENBQUE7SUFDWCx3QkFBYSxDQUFBO0lBQ2Isd0JBQWEsQ0FBQTtJQUNiLHNCQUFXLENBQUE7SUFDWCw0QkFBaUIsQ0FBQTtJQUNqQiwwQkFBZSxDQUFBO0lBQ2YsMEJBQWUsQ0FBQTtJQUNmLDhCQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFWVyxPQUFPLEtBQVAsT0FBTyxRQVVsQjtBQUVELE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRywyRkFBMkYsQ0FBQSJ9